var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserHeart = function SvgUserHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 43,
    fill: "none",
    viewBox: "0 0 43 43"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1061_2639)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h43v43H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2,
    d: "M20.369 17.509a7.819 7.819 0 100-15.638 7.819 7.819 0 000 15.638z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M35.058 38.68c-.793-4.354.826-8.291-2.571-11.127a18.898 18.898 0 00-30.7 11.127h33.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M37.027 26.495a4.75 4.75 0 00-2.226.55 4.704 4.704 0 00-1.701 1.526 4.712 4.712 0 00-2.325-1.8 4.757 4.757 0 00-2.948-.08 4.718 4.718 0 00-2.42 1.672 4.65 4.65 0 00-.946 2.77c0 5.408 6.282 8.305 8.639 10.237 2.356-1.932 8.638-4.83 8.638-10.238a4.635 4.635 0 00-1.387-3.285 4.717 4.717 0 00-3.324-1.352z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1061_2639"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h43v43H0z"
  })))));
};
export default SvgUserHeart;